import React from "react"
import useMobileMode from "../../shared/hooks/useMobileMode"
import Layout from "../../shared/components/organisms/layout/layout"
import EventsContent from "../../components/organisms/events-content/events-content"
import SEO from "../../shared/components/seo"
import "../../shared/_shared/Index.scss"

const EventsGridTemplate = ({ pageContext: { events, academyInfo, articles, category = null, language } }) => {
    const { isMobile, currentPage } = useMobileMode()

    const concatEventArticles = [].concat(events || []).concat(articles || [])
    const sectionInfo = category || academyInfo
    const seoImg = "https:" + academyInfo?.bannerPrincipal[0]?.bannerDesktop?.file?.url

    concatEventArticles.forEach(event => {
        //set format
        let eventFormat = event.tipoDeEvento?.toLowerCase() || "articulo"
        event["eventFormat"] = eventFormat
        
        let eventThemes = event.etiquetas || []
        //set themes
        event["eventThemes"] = eventThemes.reduce((acc, el) =>
            acc.concat((el.nombreDeEtiqueta?.toLowerCase() || "todos") + " "), "")

        //set directed at
        let eventManaged = event.dirigidoA || []
        event["eventManaged"] = eventManaged.reduce((acc, el) =>
            acc.concat((el?.nombreDeEtiqueta?.toLowerCase() || el?.titulo?.toLowerCase() || "todos") + " "), "")

        //set content type
        event["eventContentType"] = event.esUnEventoExclusivo ? "exclusivo" : "general"
    })

    return (
      <Layout title={sectionInfo.metaTitulo} isMobile={isMobile} currentPage={currentPage}>
        <SEO
          title={sectionInfo.metaTitulo}
          description={sectionInfo.metaDescripcion?.metaDescripcion || ""}
          lang={language}
          image={seoImg}
        />
        <EventsContent
          events={concatEventArticles}
          sectionInfo={sectionInfo}
          academyInfo={academyInfo}
        />
      </Layout>
    )
}

export default EventsGridTemplate
